import { APP_DIALOG_NAMES, DIALOG_NAME_COMPONENT_MAP } from './app-dialog-manager.const';
import ShareModuleBridge from '@/components/Project/share/share-module-bridge';
import store from '@/store';
import {
	openDialog as openDialogAction,
	closeCurrentDialog as closeCurrentDialogAction,
	closeAllDialogs as closeAllDialogsAction,
} from '@/store/modules/dialogs/actions';
import { getCurrentOpenDialog } from '@/store/modules/dialogs/getters';

/* Private */
const openDialog = (dialogName, dialogProps, dialogListeners) =>
	new Promise((resolve, reject) => {
		const payload = {
			dialogName,
			component: DIALOG_NAME_COMPONENT_MAP[dialogName],
			dialogProps: { ...dialogProps, dialogName, dialogPromiseHandlers: { resolve, reject } },
			dialogListeners,
		};
		return store.dispatch(openDialogAction.fullPath, payload);
	});

/* Public */
const closeCurrentDialog = () => {
	const currentDialog = store.getters[getCurrentOpenDialog.fullPath].dialogProps.dialogPromiseHandlers;
	currentDialog.resolve();
	store.dispatch(closeCurrentDialogAction.fullPath);
};
const closeAllDialogs = async () => await store.dispatch(closeAllDialogsAction.fullPath);

const openShareDialog = (p) =>
	ShareModuleBridge.openShareModuleDialog(p.workflowId, p.canShare, (props) =>
		openDialog(APP_DIALOG_NAMES.SHARE_DIALOG, { ...p, ...props })
	);
const openIntegrationDialog = (props) => openDialog(APP_DIALOG_NAMES.INTEGRATION_DIALOG, props);
const openConfirmationDialog = (props) => openDialog(APP_DIALOG_NAMES.CONFIRMATION_DIALOG, props);
const openSyncedGroupDialog = (props) => openDialog(APP_DIALOG_NAMES.SYNCED_GROUP_DIALOG, props);
const openManualGroupDialog = (props) => openDialog(APP_DIALOG_NAMES.MANUAL_GROUP_DIALOG, props);
const openChooseSyncedGroupTypeAndUsersDialog = (props) => openDialog(APP_DIALOG_NAMES.SYNCED_GROUP_TYPE_AND_USERS_DIALOG, props);
const openGroupPermissionsDialog = (props) => openDialog(APP_DIALOG_NAMES.GROUPS_PERMISSIONS_DIALOG, props);
const openMergeColumnDialog = (props) => openDialog(APP_DIALOG_NAMES.MERGE_COLUMN_DIALOG, props);
const openColumnsPreviewDialog = (props) => openDialog(APP_DIALOG_NAMES.COLUMNS_PREVIEW_DIALOG, props);
const openPreviewSettingsDialog = (props) => openDialog(APP_DIALOG_NAMES.PREVIEW_SETTINGS_DIALOG, props);
const openChangePasswordDialog = (props) => openDialog(APP_DIALOG_NAMES.CHANGE_PASSWORD_DIALOG, props);
const openModuleSettingsDialog = (props) => openDialog(APP_DIALOG_NAMES.MODULE_SETTINGS_DIALOG, props);
const openFeatureAppearanceSettingsDialog = (props) => openDialog(APP_DIALOG_NAMES.FEATURE_APPEARANCE_SETTINGS_DIALOG, props);
const openRespondConfigurationDialog = (props) => openDialog(APP_DIALOG_NAMES.RESPOND_CONFIGURATION_DIALOG, props);
const openSuggestCredentialsTypeDialog = (props) => openDialog(APP_DIALOG_NAMES.SUGGEST_CREDENTIALS_TYPE_DIALOG, props);
const openChangeConnectionMappingDialog = (props) => openDialog(APP_DIALOG_NAMES.CONNECTION_MAPPING_DIALOG, props);
const openChangeMappingBlockMappingDialog = (props) => openDialog(APP_DIALOG_NAMES.MAPPING_BLOCK_MAPPING_DIALOG, props);
const openUserSchemaMappingRespondDialog = (props) => openDialog(APP_DIALOG_NAMES.USER_SCHEMA_MAPPING_DIALOG, props);
const openInstallationDialog = (props) => openDialog(APP_DIALOG_NAMES.INSTALLATION_DIALOG, props);
const openSettingsDialog = (props) => openDialog(APP_DIALOG_NAMES.SETTINGS_DIALOG, props);
const openStudioModeRestrictedDialog = (props) => openDialog(APP_DIALOG_NAMES.STUDIO_MODE_RESTRICTED_DIALOG, props);
const openPrivacyAndSecurityDialog = (props) => openDialog(APP_DIALOG_NAMES.PRIVACY_AND_SECURITY_DIALOG, props);
const openGmailWorkspaceSignupDialog = (props) => openDialog(APP_DIALOG_NAMES.GMAIL_WORKSPACE_SIGNUP_DIALOG, props);
const openContinueInstallationSignupDialog = (props) => openDialog(APP_DIALOG_NAMES.CONTINUE_INSTALLATION_SIGNUP_DIALOG, props);
const openCreateMapperDialog = (props) => openDialog(APP_DIALOG_NAMES.CREATE_MAPPER_DIALOG, props);
const openAddMappingToMapperDialog = (props) => openDialog(APP_DIALOG_NAMES.ADD_MAPPING_TO_MAPPER_DIALOG, props);
const openTitleSelectionForMappingDialog = (props) => openDialog(APP_DIALOG_NAMES.TITLE_SELECTION_FOR_MAPPING_DIALOG, props);
const openFinishedCreatingMapperDialog = (props) => openDialog(APP_DIALOG_NAMES.FINISHED_CREATING_MAPPER_DIALOG, props);
const openOnboardingTextEditorDialog = (props) => openDialog(APP_DIALOG_NAMES.ONBOARDING_TEXT_EDITOR_DIALOG, props);
const openUpdateProjectConnectionDialog = (props) => openDialog(APP_DIALOG_NAMES.UPDATE_PROJECT_CONNECTION_DIALOG, props);
const openNewProjectDialog = (props) => openDialog(APP_DIALOG_NAMES.NEW_PROJECT_DIALOG, props);
const openProjectSettingsDialog = (props) => openDialog(APP_DIALOG_NAMES.PROJECT_SETTINGS_DIALOG, props);
const openCollaborateNewProjectDialog = (props) => openDialog(APP_DIALOG_NAMES.COLLABORATE_NEW_PROJECT_DIALOG, props);
const openDeleteBlockDialog = (props) => openDialog(APP_DIALOG_NAMES.DELETE_BLOCK_DIALOG, props);
const openCreationWizardDialog = (props) => openDialog(APP_DIALOG_NAMES.CREATION_WIZARD_DIALOG, props);
const openMoveProjectDialog = (props) => openDialog(APP_DIALOG_NAMES.MOVE_PROJECT_DIALOG, props);
const openInfoDialog = (props) => openDialog(APP_DIALOG_NAMES.INFO_DIALOG, props);
const openPublishFlowErrorsDialog = (props) => openDialog(APP_DIALOG_NAMES.PUBLISH_FLOW_ERRORS_DIALOG, props);
const openGuidedTutorialsChapterListDialog = (props) => openDialog(APP_DIALOG_NAMES.GUIDED_TUTORIALS_CHAPTER_LIST_DIALOG, props);
const openMeetOurTeamDialog = (props) => openDialog(APP_DIALOG_NAMES.MEET_OUR_TEEM_DIALOG, props);
const openEditCommandBarShortcutDialog = (props) => openDialog(APP_DIALOG_NAMES.EDIT_COMMAND_BAR_SHORTCUT_DIALOG, props);
const openIFrameDialog = (props) => openDialog(APP_DIALOG_NAMES.IFRAME_DIALOG, props);
const openListingDetailsDialog = (props) => openDialog(APP_DIALOG_NAMES.LISTING_DETAILS_DIALOG, props);
const openInstallationCompleteDialog = (props) => openDialog(APP_DIALOG_NAMES.INSTALLATION_COMPLETE_DIALOG, props);
const openProductHuntDialog = (props) => openDialog(APP_DIALOG_NAMES.PRODUCT_HUNT_DIALOG, props);
const openWelcomeToPlyDialog = (props) => openDialog(APP_DIALOG_NAMES.WELCOME_TO_PLY_DIALOG, props);
const openChangeOwnerDialog = (props) => openDialog(APP_DIALOG_NAMES.CHANGE_ACCOUNT_OWNER, props);
const openInboxDialog = (props) => openDialog(APP_DIALOG_NAMES.INBOX_DIALOG, props);
const openInstallExtDialog = (props) => openDialog(APP_DIALOG_NAMES.INSTALL_EXT_DIALOG, props);
const openIdeaDialog = (props) => openDialog(APP_DIALOG_NAMES.IDEA_DIALOG, props);
const openHelpBuildingIdeaDialog = (props) => openDialog(APP_DIALOG_NAMES.HELP_BUILDING_IDEA_DIALOG, props);
const openWorkspaceChangedDialog = (props) => openDialog(APP_DIALOG_NAMES.WORKSPACE_CHANGED_DIALOG, props);
const openLeaveWorkspaceDialog = (props) => openDialog(APP_DIALOG_NAMES.LEAVE_WORKSPACE_DIALOG, props);
const openCreateWorkspaceDialog = (props) => openDialog(APP_DIALOG_NAMES.CREATE_WORKSPACE_DIALOG, props);
const openDangerConfirmationDialog = (props) => openDialog(APP_DIALOG_NAMES.DANGER_CONFIRMATION_DIALOG, props);
const openConfigurationsMigrationDialog = (props) => openDialog(APP_DIALOG_NAMES.CONFIGURATIONS_MIGRATION_DIALOG, props);
const openNewOutputBlockDialog = (props) => openDialog(APP_DIALOG_NAMES.NEW_OUTPUT_BLOCK_DIALOG, props);
const openNewSubflowBlockDialog = (props) => openDialog(APP_DIALOG_NAMES.NEW_SUBFLOW_BLOCK_DIALOG, props);
const openConvertToSubflowBlockDialog = (props) => openDialog(APP_DIALOG_NAMES.CONVERT_TO_SUBFLOW_BLOCK_DIALOG, props);
const openSubflowTestDialog = (props) => openDialog(APP_DIALOG_NAMES.SUBFLOW_TEST_DIALOG, props);
const openPublishWorkflowDialog = (props) => openDialog(APP_DIALOG_NAMES.PUBLISH_WORKFLOW_DIALOG, props);
const openEditButtonDropdownDesignDialog = (props) => openDialog(APP_DIALOG_NAMES.BUTTON_DROPDOWN_DESIGN_DIALOG, props);
const openWorkflowsSelectionDialog = (props) => openDialog(APP_DIALOG_NAMES.WORKFLOWS_SELECTION_DIALOG, props);
const openUpgradePlanDialog = (props) => openDialog(APP_DIALOG_NAMES.UPGRADE_PLAN_DIALOG, props); // NEVER CALL THIS DIRECTLY. USE BillingService.openUpgradePlanDialog
const openUpgradeMultiplePlansDialog = (props) => openDialog(APP_DIALOG_NAMES.UPGRADE_MULTIPLE_PLANS_DIALOG, props); // NEVER CALL THIS DIRECTLY. USE BillingService.openUpgradeMultiplePlansDialog
const openBillingPriceMapDialog = (props) => openDialog(APP_DIALOG_NAMES.BILLING_PRICE_LIST_DIALOG, props);
const openSmartUpgradeDialog = (props) => openDialog(APP_DIALOG_NAMES.SMART_UPGRADE_DIALOG, props);
const openEditApiDocDialog = (props) => openDialog(APP_DIALOG_NAMES.EDIT_API_DOC_DIALOG, props);
const openDeleteApiDocDialog = (props) => openDialog(APP_DIALOG_NAMES.DELETE_API_DOC_DIALOG, props);
const openPricingBreakdownDialog = (props) => openDialog(APP_DIALOG_NAMES.PRICING_BREAKDOWN_DIALOG, props);
const openResetConvApiDocDialog = (props) => openDialog(APP_DIALOG_NAMES.RESET_CONV_API_DOC_DIALOG, props);
const openNewCustomDomainDialog = (props) => openDialog(APP_DIALOG_NAMES.ADD_CUSTOM_DOMAIN_DIALOG, props);
const openSetCustomDomainForWorkflowDialog = (props) => openDialog(APP_DIALOG_NAMES.SET_CUSTOM_DOMAIN_FOR_WORKFLOW_DIALOG, props);
const openAddEmailDomainDialog = (props) => openDialog(APP_DIALOG_NAMES.ADD_EMAIL_DOMAIN_DIALOG, props);
const openChangeEmailTemplateDialog = (props) => openDialog(APP_DIALOG_NAMES.CHANGE_EMAIL_TEMPLATE_DIALOG, props);
const openVerifyReplyToEmailDialog = (props) => openDialog(APP_DIALOG_NAMES.VERIFY_REPLY_TO_EMAIL_DIALOG, props);
const openRunFailInfoDialog = (props) => openDialog(APP_DIALOG_NAMES.RUN_FAIL_INFO_DIALOG, props);
const openCouldntDowngradeBillingPlanDialog = (props) => openDialog(APP_DIALOG_NAMES.COULDNT_DOWNGRADE_BILLING_PLAN, props);
const openPublishFailedBecauseBillingPlanDialog = (props) => openDialog(APP_DIALOG_NAMES.PUBLISH_FAILED_BECAUSE_BILLING_PLAN, props);
const openDeleteFeatureDialog = () =>
	openConfirmationDialog({
		title: 'Are you sure you want to delete this feature?',
		description: 'It might take a minute to complete this action',
		yesText: 'Delete',
		noText: 'Cancel',
	});

export const openPortalAuthSettings = (props) => openDialog(APP_DIALOG_NAMES.PORTAL_AUTH_SETTINGS_DIALOG, props);

export default {
	openPricingBreakdownDialog,
	openIFrameDialog,
	openPublishFailedBecauseBillingPlanDialog,
	openCouldntDowngradeBillingPlanDialog,
	openRunFailInfoDialog,
	openUpgradePlanDialog,
	openUpgradeMultiplePlansDialog,
	openWorkflowsSelectionDialog,
	openEditButtonDropdownDesignDialog,
	openEditApiDocDialog,
	openDeleteApiDocDialog,
	openResetConvApiDocDialog,
	openPublishWorkflowDialog,
	openDangerConfirmationDialog,
	openCreateWorkspaceDialog,
	openWorkspaceChangedDialog,
	openIdeaDialog,
	openProductHuntDialog,
	openWelcomeToPlyDialog,
	openInstallationCompleteDialog,
	openListingDetailsDialog,
	openMeetOurTeamDialog,
	openEditCommandBarShortcutDialog,
	openShareDialog,
	closeCurrentDialog,
	openNewProjectDialog,
	openIntegrationDialog,
	openSyncedGroupDialog,
	openManualGroupDialog,
	openConfirmationDialog,
	openChooseSyncedGroupTypeAndUsersDialog,
	openGroupPermissionsDialog,
	openMergeColumnDialog,
	openColumnsPreviewDialog,
	openPreviewSettingsDialog,
	openProjectSettingsDialog,
	openChangePasswordDialog,
	openModuleSettingsDialog,
	openFeatureAppearanceSettingsDialog,
	openRespondConfigurationDialog,
	openSuggestCredentialsTypeDialog,
	openChangeConnectionMappingDialog,
	openChangeMappingBlockMappingDialog,
	openInstallationDialog,
	openPrivacyAndSecurityDialog,
	openGmailWorkspaceSignupDialog,
	openContinueInstallationSignupDialog,
	openUserSchemaMappingRespondDialog,
	openCreateMapperDialog,
	openAddMappingToMapperDialog,
	openTitleSelectionForMappingDialog,
	openFinishedCreatingMapperDialog,
	openSettingsDialog,
	openStudioModeRestrictedDialog,
	openOnboardingTextEditorDialog,
	openUpdateProjectConnectionDialog,
	openCollaborateNewProjectDialog,
	openDeleteBlockDialog,
	openCreationWizardDialog,
	openMoveProjectDialog,
	openInfoDialog,
	openPublishFlowErrorsDialog,
	openGuidedTutorialsChapterListDialog,
	openChangeOwnerDialog,
	openInboxDialog,
	openInstallExtDialog,
	openHelpBuildingIdeaDialog,
	openLeaveWorkspaceDialog,
	closeAllDialogs,
	openConfigurationsMigrationDialog,
	openNewOutputBlockDialog,
	openNewSubflowBlockDialog,
	openConvertToSubflowBlockDialog,
	openSubflowTestDialog,
	openBillingPriceMapDialog,
	openSmartUpgradeDialog,
	openDeleteFeatureDialog,
	openAddEmailDomainDialog,
	openChangeEmailTemplateDialog,
	openVerifyReplyToEmailDialog,
	openNewCustomDomainDialog,
	openSetCustomDomainForWorkflowDialog,
};
